import Serializable from "@/core/misc/mixins/Serializable";
import Utils from "@/core/utils/Utils";
import Dimension from "@/core/types/Dimension";
import Weight from "@/core/types/Weight";

class PalletType extends Serializable {

  id:   number;
  code: string;
  length: Dimension;
  width: Dimention;
  weight: Weight;
  name?: string;

  static isPalletType(value: unknown): value is PalletType {
    return value instanceof PalletType;
  }
  static fromServer(palletTypeData: any, palletType: PalletType = new PalletType()): PalletType {
    super.fromServer(palletTypeData, palletType);

    palletType.code    = palletTypeData.code;
    palletType.length  = Utils.hydrate(palletTypeData.length, Dimension.fromServer)!;
    palletType.width   = Utils.hydrate(palletTypeData.width, Dimension.fromServer)!;
    palletType.weight  = Utils.hydrate(palletTypeData.weight, Weight.fromServer)!;


    return palletType;
  }
}

export default PalletType;
